import { render, staticRenderFns } from "./xueyuan.vue?vue&type=template&id=2dc2530a&scoped=true"
import script from "./xueyuan.vue?vue&type=script&lang=js"
export * from "./xueyuan.vue?vue&type=script&lang=js"
import style0 from "./xueyuan.vue?vue&type=style&index=0&id=2dc2530a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2530a",
  null
  
)

export default component.exports